module.exports = __webpack_public_path__ + "img/search-icon-black.362d1d75.svg";